<template>
    <div :id="`lm-form-subtitles-builder-ui-${id}`" class="row">
      <LmTextInput
        :id="`label-${id}`"
        class="col-12 col-md-4"
        v-model="component.componentProps.text"
        @input="$emit('input', component)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'

import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  components: {
    LmTextInput,
    LmSelect,
    LmConditionalBuilderUi
  }
}
</script>
